import * as React from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, Grid, DialogActions, Button, Input, FormControlLabel, Checkbox, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getLocalStorageValue } from 'src/effects/utils/local-storage';
import { getEmailNotificationSettingCall } from 'src/effects/api/api.survey';


export default class ReminderConfigurationComponent extends React.Component<any, any>  {
    constructor(props: any) {
        super(props);

        this.state = {
            showDialog: false,
            fullWidth: true,
            maxWidth: 'sm',
            sendReminder: true,
            frequency: '',
            surveyId: '',
            surveys: []
        }

        this.handleClose = this.handleClose.bind(this);
        this.handleReminderSubmit = this.handleReminderSubmit.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSurvyeYearChange = this.handleSurvyeYearChange.bind(this);
    }

    componentDidMount() {
        if (this.props.selectedSurveyId) {
            getEmailNotificationSettingCall('').then((res: any) => {
                let frequency = 0;
                let surveyId = 0;
                let isSendForSurveyNotSubmitted = false;
                if (res) {
                    if (res.data && res.data.payload) {
                        frequency = res.data.payload.frequency;
                        surveyId = res.data.payload.surveyId;
                        isSendForSurveyNotSubmitted = res.data.payload.isSendForSurveyNotSubmitted;
                    }
                }

                const surveys = this.props.surveys.length > 0 && this.props.surveys.filter((item : any) => item.statusText === 'Active' );

                this.setState({ frequency, sendReminder: isSendForSurveyNotSubmitted, surveyId, surveys });
            })
        }
    }

    // survey change from drop down 
    handleSurvyeYearChange(event: any) {
        this.setState({ surveyId: event.target.value });
    }

    handleClose() {
        this.props.onDialogClose();
    }

    handleReminderSubmit = (e: any) => {
        this.setState({ sendReminder: e.target.checked });
    }

    handleFrequency = (e: any) => {
        this.setState({ frequency: e.target.value });
    }

    handleSave = () => {
        const user = getLocalStorageValue('user');
        const data = {
            survey_id: this.state.surveyId,
            userId: user.id,
            frequency: this.state.frequency ? this.state.frequency : 0,
            Is_send_for_survey_not_submitted: this.state.sendReminder
        }
        if (data) {
            this.props.saveReminderConfig(data);
        }
        this.handleClose();
    }

    render() {
        return (
            <>
                <Dialog
                    fullWidth={this.state.fullWidth}
                    hideBackdrop={true}
                    maxWidth={this.state.maxWidth}
                    open={this.props.showDialog}
                    aria-labelledby="max-width-dialog-title"
                    className="applicationDialog"
                >
                    <div className="dialogWrapper">
                        <div className="dialogHead">
                            <DialogTitle id="max-width-dialog-title" className="dialogTitle">Reminder frequency
                        <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                    <CloseIcon />
                                </IconButton>
                                <hr className="HZDivider" />
                            </DialogTitle>
                        </div>

                        <div className="dialogContent">
                            <DialogContent>
                                <Grid container={true} spacing={24} justify="center" alignItems="center">
                                    <Grid item={true} xs={4}>
                                        <label>Select Survey</label>
                                    </Grid>
                                    <Grid item={true} xs={8}>
                                        <FormControl margin="normal" required={false} fullWidth={true}>
                                            <Select
                                                value={this.state.surveyId ? this.state.surveyId : ''}
                                                displayEmpty={true}
                                                onChange={this.handleSurvyeYearChange}
                                                placeholder={"Select Survey"}
                                                inputProps={{
                                                    name: "title",
                                                    id: "surveyId"
                                                }}
                                            >
                                                <MenuItem value='' key="">Survey</MenuItem>    
                                            {
                                                this.state.surveys.length > 0 && this.state.surveys.map((item: any, key: any) => {
                                                    return <MenuItem
                                                        value={item.id}
                                                        key={key}
                                                        data-my-value={item.year}
                                                    >
                                                        {item.title + " " + item.year}
                                                    </MenuItem>
                                            })
                                            }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item={true} xs={4}>
                                        <label className="">Send reminders every</label>
                                    </Grid>
                                    <Grid item={true} xs={8}>
                                            <FormControl margin="normal" required={false} fullWidth={true}>
                                                <InputLabel htmlFor="clusterName">Days</InputLabel>
                                                <Input
                                                    type="number"
                                                    fullWidth={true}
                                                    value={this.state.frequency ? this.state.frequency : ''}
                                                    onChange={this.handleFrequency}
                                                />
                                            </FormControl>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.sendReminder}
                                                        onChange={this.handleReminderSubmit}
                                                    />
                                                }
                                                label="Send reminders only if the survey is not submitted"
                                            />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </div>

                        <div className="dialogAction">
                            <DialogActions>
                                <Button
                                    color="primary"
                                    className="btn-blue-primary"
                                    onClick={this.handleSave}
                                >
                                    Save &nbsp; >
                                </Button>
                            </DialogActions>
                        </div>
                    </div>
                </Dialog>
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/ReminderConfigurationComponent.tsx